import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { InputComponent } from '@app/modules/change-requests/interfaces/input-component.class';
import { ValueInputDirective } from '@change-requests/directives/value-input.directive';
import { InputComponentsService } from '@change-requests/services';
import { FieldValue } from '@change-requests/types/field.value.type';

@Component({
    selector: 'field-value-input-component',
    template: `
        <div>
            <ng-template valueInput></ng-template>
        </div>
    `,
})
export class FieldValueInputComponent implements OnInit {
    @Input() value: FieldValue = '';
    @Input() initialValue: FieldValue;
    @Input() fieldKey = '';
    @Input() set errorMessage(errorMessage: string) {
        if (this.componentRef) {
            this.componentRef.instance.errorMessage = errorMessage;
        }
        this._errorMessage = errorMessage;
    }
    get errorMessage(): string | undefined {
        return this._errorMessage;
    }
    @Input() 'aria-label'?: string;

    // Simulate input binding on the disabled attribute for dynamic components.
    @Input() set disabled(value: boolean) {
        this.isDisabled = value;

        if (this.componentRef) {
            this.componentRef.instance.disabled = this.isDisabled;

            // Revert to initial value if disabled
            if (this.isDisabled) {
                this.componentRef.instance.value = this.initialValue;
            }

            // Emit the current value if enabled
            if (!this.isDisabled) {
                this.valueUpdated.emit(this.componentRef.instance.value);
            }
        }
    }

    @Output() valueUpdated: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild(ValueInputDirective, { static: true }) valueInput!: ValueInputDirective;

    isDisabled = false;
    protected componentRef: any;
    private _errorMessage?: string;

    constructor(private inputComponentsService: InputComponentsService) {}

    ngOnInit(): void {
        const inputComponent = this.inputComponentsService.getComponentClass(this.fieldKey);

        if (!inputComponent) {
            throw new Error('No display component defined or configuration is missing');
        }

        const viewContainerRef = this.valueInput.viewContainerRef;
        viewContainerRef.clear();

        this.componentRef = viewContainerRef.createComponent<InputComponent>(inputComponent);

        this.componentRef.instance.value = this.value;
        this.componentRef.instance.disabled = this.isDisabled;
        this.componentRef.instance.ariaLabel = this['aria-label'];
        this.componentRef.instance.errorMessage = this.errorMessage;

        /*
         * All fields have an emitter for valueUpdated.  When the event is emitted, we capture the value and
         * re-emit to pass up to the parent component.
         */
        this.componentRef.instance.valueUpdated.subscribe((newValue) => {
            this.valueUpdated.emit(newValue);
        });
    }
}
